import React from 'react';
import Logo from "../Components/Logo";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from "../Services/API";

export default function Splash(props) {
    const navigate = useNavigate();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
            const token = match ? match[2] : null;
            if(token) {
                API.getUserInfo()
                    .then((response) => {
                        window.localStorage.setItem("spr",  JSON.stringify(response.data.user.s_permissions));
                    })
                    .catch((error) => {

                    });
                navigate('/home');
                return;
            }
            navigate('/login');
        }, 2000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (
        <React.Fragment>
            <section className="container-fluid splash " >

                <div className="row">
                    <div className="col-12 mt-4 ">
                        <Logo size={150} />
                    </div>
                    <h2 className="col-12 text-center mt-5 title text-white fw-bold">

                        گروه صنعتی نیروگستران خراسان
                    </h2>
                    <h6 className="col-12 text-center mt-4 text-white-50 text-small-1">
                        سامانه  فروش
                    </h6>
                    <div className="col-12 text-center fixed-bottom mb-3">
                        <div className="spinner-grow text-warning" role="status">

                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
